import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { OrderFormComponent } from './order-form/order-form.component';

@Component({
  selector: 'app-enter-order',
  templateUrl: './enter-order.component.html',
  styleUrls: ['./enter-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnterOrderComponent implements OnInit {

  @ViewChild('orderForm') orderFormComponent: OrderFormComponent;

  isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  enterDetailsClicked(): void {
    this.isOpen$.next(true);
  }

  cancelClicked(): void { 
    this.isOpen$.next(false);
  }

  getForm(): UntypedFormGroup {
    this.cdr.detectChanges();
    return this.orderFormComponent?.form;
  }
  
}
